!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.Tracker = e(require("react")) : t.Tracker = e(t.react);
}(window, function (t) {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 0);
  }([function (t, e, n) {
    "use strict";

    (function (t) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(5);
      e.Trackable = r.Trackable;
      var o = n(7);
      e.createTracker = o.createTracker;
      var i = n(22);
      e.trackAction = i.trackAction;
      var a = n(23);
      e.trackCategory = a.trackCategory;
      var s = n(24);
      e.trackerDecorator = s.trackerDecorator;
      var c,
          u = n(25),
          l = n(2),
          p = n(4);
      e.tracker = c, p && !t.env.__RUN_TEST__ ? e.tracker = c = new u.FakeTracker() : e.tracker = c = new l.Tracker();
    }).call(this, n(1));
  }, function (t, e) {
    var n,
        r,
        o = t.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function s(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (t) {
        n = i;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        r = a;
      }
    }();
    var c,
        u = [],
        l = !1,
        p = -1;

    function f() {
      l && c && (l = !1, c.length ? u = c.concat(u) : p = -1, u.length && d());
    }

    function d() {
      if (!l) {
        var t = s(f);
        l = !0;

        for (var e = u.length; e;) {
          for (c = u, u = []; ++p < e;) {
            c && c[p].run();
          }

          p = -1, e = u.length;
        }

        c = null, l = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }

    function h(t, e) {
      this.fun = t, this.array = e;
    }

    function v() {}

    o.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      u.push(new h(t, e)), 1 !== u.length || l || s(d);
    }, h.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = v, o.addListener = v, o.once = v, o.off = v, o.removeListener = v, o.removeAllListeners = v, o.emit = v, o.prependListener = v, o.prependOnceListener = v, o.listeners = function (t) {
      return [];
    }, o.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__assign || Object.assign || function (t) {
      for (var e, n = 1, r = arguments.length; n < r; n++) {
        for (var o in e = arguments[n]) {
          Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        }
      }

      return t;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(3),
        i = n(11),
        a = n(20),
        s = function () {
      function t() {
        var t = this;
        this.DOMInteraction = new o.DOMInteraction(), this.defaultOptions = {
          disableCatchClickOnLinks: !1
        }, this.contextVariables = void 0, this.version = "2.4.3", this.visitTime = 0, this.initialUseType = "direct", this.useType = this.initialUseType, this.devMode = !1, this.isHTMLTracking = !1, this.excludedJsEvents = ["javascript:", "javascript:void(0)", "javascript:void(0);", "javascript:;", "javascript: void 0"], this.assignQueue = function (e) {
          return Array.isArray(e) && (e.forEach(t.push), e.push = t.push), t;
        }, this.push = function (e) {
          Array.isArray(e) ? t.callMethodByEventType(e) : console.error("Pushed event must be an array");
        }, this.trackEvent = function (e, n, r, o) {
          t.sendRequestWithProps({
            category: e,
            action: n,
            label: r,
            customVariables: o
          });
        }, this.sendRequestWithProps = function (e, n, o) {
          o && t.setUseType(o), e && t.contextVariables && (void 0 === e.customVariables ? e.customVariables = t.contextVariables : "object" != typeof e.customVariables || null === e.customVariables || e.customVariables instanceof Array || (e.customVariables = r({}, t.contextVariables, e.customVariables))), t.sendRequest(e, t.trackerProps, n), t.resetUseType();
        }, this.onDocumentLoaded = function (t) {
          Array.isArray(t) && ("complete" === document.readyState || "interactive" === document.readyState ? t.forEach(function (t) {
            return t();
          }) : document.addEventListener("DOMContentLoaded", function () {
            t.forEach(function (t) {
              return t();
            });
          }));
        }, this.trackWebVitalsMetric = function (e) {
          t.trackEvent("auto", "web-vitals", e.name, {
            value: e.value,
            id: e.id,
            delta: e.delta,
            entries: e.entries
          });
        };
      }

      return t.prototype.initialize = function (t) {
        var e = t.siteID,
            n = t.trackerENV,
            r = t.devMode,
            o = t.options;
        return this.throwIfIncorrectProps(e, n), this.ID = e, this.ENV = n, r ? this.enableDevMode() : this.enableProdMode(), this.setUpTimer(), this.options = o || this.defaultOptions, this.setOptions(this.options), this;
      }, t.prototype.trackPageVisit = function (t) {
        this.resetTrackerProps(), this.trackEvent("auto", "visitPage", t || document.title), this.setUpTimer();
      }, t.prototype.trackElement = function (t, e, n) {
        var r = this;
        void 0 !== t.addEventListener ? t.addEventListener(e, function () {
          r.sendRequestWithProps(n, t, "HTMLElement");
        }) : console.error("Element doesn't have 'addEventListener' property");
      }, t.prototype.setUseType = function (t) {
        this.useType = t;
      }, t.prototype.resetUseType = function () {
        this.useType = this.initialUseType;
      }, t.prototype.validateHTML = function (t) {
        var e,
            n = this;
        return e = this.DOMInteraction.getElements(t).reduce(function (t, e) {
          var r = [],
              o = n.DOMInteraction.extractParamsFromElement(e);
          void 0 === o.category && r.push("empty category");
          var i = {
            element: e,
            params: o,
            errors: r
          };
          return t.push(i), r.length && console.error('element "' + o.category + '": "' + o.action + '" contain errors: ' + r.map(function (t) {
            return '"' + t + '"';
          }).join(",  "), i), t;
        }, []), console.log(e), e;
      }, t.prototype.enableDevMode = function () {
        this.devMode = !0, this.throwIfIncorrectProps(this.ID, this.ENV), this.sendRequest = i.getSendRequest("dev", this.ID, this.ENV);
      }, t.prototype.enableHTMLTracking = function () {
        if (!this.isHTMLTracking) {
          this.isHTMLTracking = !0;
          var t = this.options && this.options.root,
              e = this.DOMInteraction.getElements(t);

          if (e.length) {
            for (var n = 0; n < e.length; n++) {
              this.autoTrackElement(e[n]);
            }

            this.devMode && this.validateHTML(t);
          }
        }
      }, t.prototype.setEventsContext = function (t) {
        this.contextVariables = t;
      }, t.prototype.autoTrackElement = function (t) {
        switch (t.tagName) {
          case "INPUT":
            switch (t.type) {
              case "submit":
              case "reset":
              case "button":
                this.trackElement(t, "click", null);
                break;

              default:
                this.trackElement(t, "change", null);
            }

            break;

          case "TEXTAREA":
          case "SELECT":
            this.trackElement(t, "change", null);
            break;

          case "FORM":
            this.trackElement(t, "submit", null);
            break;

          default:
            this.trackElement(t, "click", null);
        }
      }, t.prototype.enableProdMode = function () {
        this.devMode = !1, this.throwIfIncorrectProps(this.ID, this.ENV), this.sendRequest = i.getSendRequest("prod", this.ID, this.ENV);
      }, Object.defineProperty(t.prototype, "trackerProps", {
        get: function get() {
          return {
            visitTime: this.visitTime,
            useType: this.useType,
            version: this.version
          };
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.resetTrackerProps = function () {
        this.resetTimer();
      }, t.prototype.setUpTimer = function () {
        var t = this;
        this.timerInstance = window.setInterval(function () {
          t.visitTime += 1;
        }, 1e3);
      }, t.prototype.resetTimer = function () {
        window.clearInterval(this.timerInstance), this.visitTime = 0;
      }, t.prototype.setOptions = function (t) {
        var e = t.catchEventsByAttributes,
            n = t.catchPageVisits,
            r = t.catchUnloadEvent,
            o = t.disableCatchClickOnLinks,
            i = t.webVitalsOptions;
        n && this.trackPageVisit(), e && this.onDocumentLoaded([this.enableHTMLTracking.bind(this)]), r && this.trackUnloadEvent(), !o && this.trackClicksOnLinks(), i && a.configureWebVitals(this.trackWebVitalsMetric, i);
      }, t.prototype.trackClicksOnLinks = function () {
        var t = this,
            e = window.open,
            n = function n(t) {
          return -1 !== t.indexOf("javascript:");
        },
            r = function r(e) {
          t.excludedJsEvents.some(function (t) {
            return t === e;
          }) || t.trackEvent("WebSecClicks", "JsLinkClick", e);
        };

        window.open = function (t) {
          for (var o = [], i = 1; i < arguments.length; i++) {
            o[i - 1] = arguments[i];
          }

          return t && n(t) && r(t), e.apply(window, [t].concat(o));
        };

        window.addEventListener("click", function (t) {
          (function (t) {
            var e = t,
                n = e.composedPath && e.composedPath() || e.path;
            if (null != n) return n.indexOf(window) < 0 ? n.concat(window) : n;
            var r = t.target;
            if (r === window) return [window];

            var o = function o(t, e) {
              e = e || [];
              var n = t.parentNode;
              return n ? o(n, e.concat(n)) : e;
            },
                i = o(r);

            return [r].concat(i, window);
          })(t).forEach(function (t) {
            var e = t,
                n = e.tagName,
                o = e.protocol,
                i = e.href;
            "A" === n && "javascript:" === o && r(i);
          });
        }), window.addEventListener("submit", function (t) {
          var e = t.target.action;
          e && n(e) && r(e);
        });
      }, t.prototype.trackUnloadEvent = function () {
        var t = this;
        window.addEventListener("beforeunload", function () {
          t.trackEvent("auto", "unload"), t.sleep(50);
        });
      }, t.prototype.sleep = function (t) {
        var e = Date.now(),
            n = null;

        do {
          n = Date.now();
        } while (n - e < t);
      }, t.prototype.callMethodByEventType = function (t) {
        var e = t[0];

        if ("trackEvent" === e) {
          var n = t,
              r = n[1],
              o = n[2],
              i = n[3],
              a = n[4];
          this.trackEvent(r, o, i, a);
        } else if ("trackPageVisit" === e) {
          var s = t[1];
          this.trackPageVisit(s);
        } else if ("trackElement" === e) {
          var c = t,
              u = c[1],
              l = c[2],
              p = c[3];
          this.trackElement(u, l, p);
        } else "enableDevMode" === e ? this.enableDevMode() : "enableHTMLTracking" === e ? this.enableHTMLTracking() : console.error('Event type "' + e + '" is not exist in Tracker');
      }, t.prototype.throwIfIncorrectProps = function (t, e) {
        if ("number" != typeof t) throw new Error("Incorrect site id");
        if ("prod" !== e && "test" !== e && "__local_test__" !== e) throw new Error("Incorrect tracker environment");
      }, t;
    }();

    e.Tracker = s;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r = this && this.__assign || Object.assign || function (t) {
        for (var e, n = 1, r = arguments.length; n < r; n++) {
          for (var o in e = arguments[n]) {
            Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
          }
        }

        return t;
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(8),
          i = n(9);
      n(4) && !t.env.__RUN_TEST__ || o.elementClosest();

      var a = function () {
        function t() {}

        return t.prototype.getElements = function (t) {
          return t ? this.getElementsInsideRoot(t) : this.getElementsInsideBody();
        }, t.prototype.extractParamsFromElement = function (t, e) {
          void 0 === e && (e = !0);
          var n = e && this.extractOptionsFromElement(t);
          return r({}, n, this.extractElementDetails(t));
        }, t.prototype.extractOptionsFromElement = function (t) {
          return {
            category: this.findElementCategory(t),
            action: t.getAttribute(i.ATTRIBUTES.action),
            label: t.getAttribute(i.ATTRIBUTES.label)
          };
        }, t.prototype.extractElementDetails = function (t) {
          var e = t,
              n = {
            elementID: t.id,
            elementTag: t.tagName
          };
          return e.type && (n.elementType = e.type), e.value && "password" !== e.type && (n.elementValue = e.value), e.form && (n = r({}, n, this.extractParamsFromForm(e.form))), "FORM" === t.tagName && (n = r({}, n, this.extractParamsFromForm(t))), n;
        }, t.prototype.extractParamsFromForm = function (t) {
          return {
            formID: t.id,
            formAction: t.action
          };
        }, t.prototype.findElementCategory = function (t) {
          var e = t.closest("[" + i.ATTRIBUTES.category + "]");
          if (e) return e.getAttribute(i.ATTRIBUTES.category);
        }, t.prototype.getElementsInsideBody = function () {
          return Array.prototype.slice.call(document.querySelectorAll("[" + i.ATTRIBUTES.action + "]")).filter(function (t) {
            return !t.closest("[" + i.ATTRIBUTES.root + "]");
          });
        }, t.prototype.getElementsInsideRoot = function (t) {
          var e = document.querySelector("[" + i.ATTRIBUTES.root + '="' + t + '"]');
          return e ? Array.prototype.slice.call(e.querySelectorAll("[" + i.ATTRIBUTES.action + "]")) : [];
        }, t;
      }();

      e.DOMInteraction = a;
    }).call(this, n(1));
  }, function (t, e, n) {
    (function (e) {
      t.exports = !1;

      try {
        t.exports = "[object process]" === Object.prototype.toString.call(e.process);
      } catch (t) {}
    }).call(this, n(10));
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__rest || function (t, e) {
      var n = {};

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
      }

      if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(t); o < r.length; o++) {
          e.indexOf(r[o]) < 0 && (n[r[o]] = t[r[o]]);
        }
      }

      return n;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = n(6),
        i = n(0);

    e.Trackable = function (t) {
      var e = t.children,
          n = r(t, ["children"]),
          a = o.Children.only(e),
          s = n.tracker || i.tracker,
          c = Object.keys(n).reduce(function (t, e) {
        if ("tracker" === e) return t;
        var r = n[e],
            o = r.category,
            i = r.action,
            c = r.label,
            u = r.customVariables;
        return t[e] = function () {
          for (var t, n = [], r = 0; r < arguments.length; r++) {
            n[r] = arguments[r];
          }

          if (s.setUseType("ReactComponent"), s.trackEvent(o, i, c, u), a.props[e]) return (t = a.props)[e].apply(t, n);
        }, t;
      }, {});
      return o.cloneElement(a, c);
    };
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(2);

    e.createTracker = function (t, e, n, o) {
      return void 0 === o && (o = !1), new r.Tracker().initialize({
        siteID: t,
        trackerENV: e,
        options: n,
        devMode: o
      });
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.elementClosest = function () {
      var t = window.Element.prototype;
      "function" != typeof t.matches && (t.matches = t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector), "function" != typeof t.closest && (t.closest = function (t) {
        for (var e = this; e && 1 === e.nodeType;) {
          if (e.matches(t)) return e;
          e = e.parentNode;
        }

        return null;
      });
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.ATTRIBUTES = {
      category: "data-km-category",
      action: "data-km-action",
      label: "data-km-label",
      root: "data-km-root"
    };
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(12),
        o = n(17),
        i = n(18),
        a = n(19);

    e.getSendRequest = function (t, e, n) {
      switch (t) {
        case "dev":
          return r.createSendRequest(o.developmentLog, e, n);

        case "prod":
          return "__local_test__" === n ? r.createSendRequest(a.xhr, e, n) : r.createSendRequest(i.request, e, n);
      }
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(13),
        o = n(16);

    e.createSendRequest = function (t, e, n) {
      return function (i, a, s) {
        var c = new r.Config(e, a, i, s),
            u = c.toQueryString(),
            l = o.endpoints[n] + "?" + u;
        return t(l, c.params);
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = this && this.__assign || Object.assign || function (t) {
      for (var e, n = 1, r = arguments.length; n < r; n++) {
        for (var o in e = arguments[n]) {
          Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        }
      }

      return t;
    };

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = n(3),
        i = n(14),
        a = n(15);
    e.paramsQueryStrings = {
      category: "c",
      action: "a",
      label: "l",
      customVariables: "cv",
      timeStamp: "ts",
      apiKey: "k",
      ID: "id",
      resolutionWidth: "rw",
      resolutionHeight: "rh",
      browserInnerWidth: "biw",
      browserInnerHeight: "bih",
      browserOuterWidth: "bow",
      browserOuterHeight: "boh",
      elementID: "eid",
      elementType: "et",
      elementTag: "etg",
      elementValue: "ev",
      formID: "efid",
      formAction: "efa",
      url: "url",
      urlRef: "urlref",
      eventIndex: "ei",
      visitTime: "vt",
      tabID: "tabid",
      useType: "ut",
      version: "ver"
    };

    var s = Object.keys(e.paramsQueryStrings),
        c = function () {
      function t(t, e, n, r) {
        this.ID = t, this.trackerProps = e, this.params = {
          timeStamp: this.getTimeStamp(),
          resolutionWidth: this.getResolution().width,
          resolutionHeight: this.getResolution().height,
          browserInnerWidth: this.getBrowserInnerResolution().width,
          browserInnerHeight: this.getBrowserInnerResolution().height,
          browserOuterWidth: this.getBrowserOuterResolution().width,
          browserOuterHeight: this.getBrowserOuterResolution().height,
          url: this.getUrl(),
          urlRef: this.getReferrer(),
          tabID: this.getTabID(),
          eventIndex: this.getEventIndex(),
          visitTime: this.getVisitTime(),
          useType: this.getUseType(),
          version: this.getVersion()
        }, this.DOMInteraction = new o.DOMInteraction(), this.getSortInOrderComparer = function (t) {
          return function (e, n) {
            var r = t.indexOf(e),
                o = t.indexOf(n);
            return r === o ? 0 : r < o ? -1 : 1;
          };
        }, this.setParams(n, r);
      }

      return t.prototype.toQueryString = function () {
        var t = this,
            n = this.getSortInOrderComparer(s);
        return Object.keys(this.params).sort(n).map(function (n) {
          return [e.paramsQueryStrings[n], t.params[n]];
        }).filter(function (t) {
          t[0];
          var e = t[1];
          return null != e;
        }).map(function (t) {
          var e = t[0],
              n = t[1];
          return e + "=" + encodeURIComponent(n.toString());
        }).join("&");
      }, t.prototype.setParams = function (t, e) {
        this.params.ID = this.ID, e && this.elementToParams(e, !t), t && this.optionsToParams(t);
      }, t.prototype.optionsToParams = function (t) {
        var e = t.category,
            n = t.action,
            r = t.label,
            o = t.customVariables;
        this.params.category = e, this.params.action = n, this.params.label = r || null, this.params.customVariables = this.parseCustomVariables(o);
      }, t.prototype.parseCustomVariables = function (t) {
        if (void 0 === t) return null;
        if ("number" == typeof t || "boolean" == typeof t) return t.toString();
        if ("string" == typeof t) return t;

        try {
          return JSON.stringify(t);
        } catch (t) {
          return null;
        }
      }, t.prototype.elementToParams = function (t, e) {
        void 0 === e && (e = !0);
        var n = this.DOMInteraction.extractParamsFromElement(t, e);
        this.params = r({}, this.params, n);
      }, t.prototype.getTimeStamp = function () {
        return i.FormatDate(new Date());
      }, t.prototype.getResolution = function () {
        return window.screen;
      }, t.prototype.getBrowserInnerResolution = function () {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        };
      }, t.prototype.getBrowserOuterResolution = function () {
        return {
          width: window.outerWidth,
          height: window.outerHeight
        };
      }, t.prototype.getUrl = function () {
        return window.location.hash ? window.location.href.split("#")[0] : window.location.href;
      }, t.prototype.getReferrer = function () {
        try {
          return window.top.document.referrer || window.parent.document.referrer || document.referrer || "";
        } catch (t) {
          return document.referrer || "";
        }
      }, t.prototype.getTabID = function () {
        if (null != window.sessionStorage) return window.sessionStorage.getItem("tabID") || this.setTabID();
      }, t.prototype.setTabID = function () {
        if (null != window.sessionStorage) return window.sessionStorage.setItem("tabID", a.getRandomString()), this.getTabID();
      }, t.prototype.getEventIndex = function () {
        if (null != window.sessionStorage) {
          var t = window.sessionStorage.getItem(this.projectEventIndexName);
          if (null == t || "" === t) return this.setNewEventIndex();
          var e = parseInt(t, 10) + 1;
          return this.updateEventIndexInStorage(e), e;
        }
      }, t.prototype.setNewEventIndex = function () {
        if (null != window.sessionStorage) return window.sessionStorage.setItem(this.projectEventIndexName, "0"), this.getEventIndex();
      }, t.prototype.updateEventIndexInStorage = function (t) {
        null != window.sessionStorage && window.sessionStorage.setItem(this.projectEventIndexName, t.toString());
      }, t.prototype.getVisitTime = function () {
        return this.trackerProps.visitTime;
      }, t.prototype.getUseType = function () {
        return this.trackerProps.useType;
      }, t.prototype.getVersion = function () {
        return this.trackerProps.version;
      }, Object.defineProperty(t.prototype, "projectEventIndexName", {
        get: function get() {
          return "trackerEventIndexForID" + this.ID;
        },
        enumerable: !0,
        configurable: !0
      }), t;
    }();

    e.Config = c;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.FormatDate = function (t) {
      return r(t.getDate()) + "." + r(t.getMonth() + 1) + "." + t.getFullYear() + " " + r(t.getHours()) + ":" + r(t.getMinutes()) + ":" + r(t.getSeconds()) + " " + e.timeOffsetInMinutesToString(t.getTimezoneOffset());
    }, e.timeOffsetInMinutesToString = function (t) {
      var e = t > 0 ? "-" : "+",
          n = Math.abs(t),
          o = Math.floor(n / 60),
          i = n % 60;
      return "GMT" + e + r(o) + ":" + r(i);
    };

    var r = function r(t) {
      return "" + (t < 10 ? "0" + t : t);
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getRandomString = function (t) {
      void 0 === t && (t = 6);

      for (var e = "", n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", r = 0; r < t; r++) {
        e += n.charAt(Math.floor(Math.random() * n.length));
      }

      return e;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.endpoints = {
      test: "https://metrika.testkontur.ru/track-event",
      prod: "https://metrika.kontur.ru/track-event",
      __local_test__: "http://localhost:3000/track-event"
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.developmentLog = function (t, e) {
      var n = e.category,
          r = e.action,
          o = e.customVariables,
          i = {
        params: e,
        link: t
      },
          a = !1,
          s = function s(t) {
        a = !0, console.error('"' + n + '": "' + r + '" has error: ' + t, i);
      };

      if (o) try {
        JSON.parse(o);
      } catch (t) {
        s("Custom variables is invalid json");
      }
      return n || s("undefined category for event"), r || s("undefined action for event"), a || console.log('"' + n + '": "' + r + '"', i), !0;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.request = function (t, e) {
      var n = e.category,
          r = e.action;
      return !(!n || !r) && (new window.Image(1, 1).src = t, !0);
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.xhr = function (t) {
      var e = new XMLHttpRequest();
      return e.open("GET", t), e.send(), !0;
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(21);

    e.configureWebVitals = function (t, e) {
      r.getLCP(t, e.reportAllChanges), r.getFID(t, e.reportAllChanges), r.getCLS(t, e.reportAllChanges), r.getFCP(t, e.reportAllChanges), r.getTTFB(t);
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e), n.d(e, "getCLS", function () {
      return d;
    }), n.d(e, "getFCP", function () {
      return g;
    }), n.d(e, "getFID", function () {
      return O;
    }), n.d(e, "getLCP", function () {
      return S;
    }), n.d(e, "getTTFB", function () {
      return _;
    });

    var r,
        o,
        i,
        a,
        s = function s(t, e) {
      return {
        name: t,
        value: void 0 === e ? -1 : e,
        delta: 0,
        entries: [],
        id: "v1-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12)
      };
    },
        c = function c(t, e) {
      try {
        if (PerformanceObserver.supportedEntryTypes.includes(t)) {
          if ("first-input" === t && !("PerformanceEventTiming" in self)) return;
          var n = new PerformanceObserver(function (t) {
            return t.getEntries().map(e);
          });
          return n.observe({
            type: t,
            buffered: !0
          }), n;
        }
      } catch (t) {}
    },
        u = function u(t, e) {
      var n = function n(r) {
        "pagehide" !== r.type && "hidden" !== document.visibilityState || (t(r), e && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
      };

      addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
    },
        l = function l(t) {
      addEventListener("pageshow", function (e) {
        e.persisted && t(e);
      }, !0);
    },
        p = "function" == typeof WeakSet ? new WeakSet() : new Set(),
        f = function f(t, e, n) {
      var r;
      return function () {
        e.value >= 0 && (n || p.has(e) || "hidden" === document.visibilityState) && (e.delta = e.value - (r || 0), (e.delta || void 0 === r) && (r = e.value, t(e)));
      };
    },
        d = function d(t, e) {
      var n,
          r = s("CLS", 0),
          o = function o(t) {
        t.hadRecentInput || (r.value += t.value, r.entries.push(t), n());
      },
          i = c("layout-shift", o);

      i && (n = f(t, r, e), u(function () {
        i.takeRecords().map(o), n();
      }), l(function () {
        r = s("CLS", 0), n = f(t, r, e);
      }));
    },
        h = -1,
        v = function v() {
      return "hidden" === document.visibilityState ? 0 : 1 / 0;
    },
        m = function m() {
      u(function (t) {
        var e = t.timeStamp;
        h = e;
      }, !0);
    },
        y = function y() {
      return h < 0 && (h = v(), m(), l(function () {
        setTimeout(function () {
          h = v(), m();
        }, 0);
      })), {
        get timeStamp() {
          return h;
        }

      };
    },
        g = function g(t, e) {
      var n,
          r = y(),
          o = s("FCP"),
          i = function i(t) {
        "first-contentful-paint" === t.name && (u && u.disconnect(), t.startTime < r.timeStamp && (o.value = t.startTime, o.entries.push(t), p.add(o), n()));
      },
          a = performance.getEntriesByName("first-contentful-paint")[0],
          u = a ? null : c("paint", i);

      (a || u) && (n = f(t, o, e), a && i(a), l(function (r) {
        o = s("FCP"), n = f(t, o, e), requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            o.value = performance.now() - r.timeStamp, p.add(o), n();
          });
        });
      }));
    },
        b = {
      passive: !0,
      capture: !0
    },
        T = new Date(),
        w = function w(t, e) {
      r || (r = e, o = t, i = new Date(), I(removeEventListener), k());
    },
        k = function k() {
      if (o >= 0 && o < i - T) {
        var t = {
          entryType: "first-input",
          name: r.type,
          target: r.target,
          cancelable: r.cancelable,
          startTime: r.timeStamp,
          processingStart: r.timeStamp + o
        };
        a.forEach(function (e) {
          e(t);
        }), a = [];
      }
    },
        E = function E(t) {
      if (t.cancelable) {
        var e = (t.timeStamp > 1e12 ? new Date() : performance.now()) - t.timeStamp;
        "pointerdown" == t.type ? function (t, e) {
          var n = function n() {
            w(t, e), o();
          },
              r = function r() {
            o();
          },
              o = function o() {
            removeEventListener("pointerup", n, b), removeEventListener("pointercancel", r, b);
          };

          addEventListener("pointerup", n, b), addEventListener("pointercancel", r, b);
        }(e, t) : w(e, t);
      }
    },
        I = function I(t) {
      ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function (e) {
        return t(e, E, b);
      });
    },
        O = function O(t, e) {
      var n,
          i = y(),
          d = s("FID"),
          h = function h(t) {
        t.startTime < i.timeStamp && (d.value = t.processingStart - t.startTime, d.entries.push(t), p.add(d), n());
      },
          v = c("first-input", h);

      n = f(t, d, e), v && u(function () {
        v.takeRecords().map(h), v.disconnect();
      }, !0), v && l(function () {
        var i;
        d = s("FID"), n = f(t, d, e), a = [], o = -1, r = null, I(addEventListener), i = h, a.push(i), k();
      });
    },
        S = function S(t, e) {
      var n,
          r = y(),
          o = s("LCP"),
          i = function i(t) {
        var e = t.startTime;
        e < r.timeStamp && (o.value = e, o.entries.push(t)), n();
      },
          a = c("largest-contentful-paint", i);

      if (a) {
        n = f(t, o, e);

        var d = function d() {
          p.has(o) || (a.takeRecords().map(i), a.disconnect(), p.add(o), n());
        };

        ["keydown", "click"].forEach(function (t) {
          addEventListener(t, d, {
            once: !0,
            capture: !0
          });
        }), u(d, !0), l(function (r) {
          o = s("LCP"), n = f(t, o, e), requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              o.value = performance.now() - r.timeStamp, p.add(o), n();
            });
          });
        });
      }
    },
        _ = function _(t) {
      var e,
          n = s("TTFB");
      e = function e() {
        try {
          var e = performance.getEntriesByType("navigation")[0] || function () {
            var t = performance.timing,
                e = {
              entryType: "navigation",
              startTime: 0
            };

            for (var n in t) {
              "navigationStart" !== n && "toJSON" !== n && (e[n] = Math.max(t[n] - t.navigationStart, 0));
            }

            return e;
          }();

          if (n.value = n.delta = e.responseStart, n.value < 0) return;
          n.entries = [e], t(n);
        } catch (t) {}
      }, "complete" === document.readyState ? setTimeout(e, 0) : addEventListener("pageshow", e);
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var r = n(0);

    e.trackAction = function (t, e) {
      return function (n, o, i) {
        var a = i.value;

        i.value = function () {
          var o,
              i = n.__TRACK_CATEGORY__ || "auto";
          e && ("string" == typeof e.label ? o = e.label : "number" == typeof e.label && (o = arguments[e.label].toString()), e.setCategory && (i = e.setCategory));
          var s = n.__TRACKER__ || r.tracker;
          return s.setUseType("decorator"), s.trackEvent(i, t, o), a.apply(this, arguments);
        };
      };
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.trackCategory = function (t) {
      return function (e) {
        e.prototype.__TRACK_CATEGORY__ = t;
      };
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.trackerDecorator = function (t) {
      return function (e) {
        e.prototype.__TRACKER__ = t;
      };
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var r = function () {
      function t() {}

      return t.prototype.initialize = function (t) {
        return this;
      }, t.prototype.trackEvent = function () {}, t.prototype.trackPageVisit = function () {}, t.prototype.trackElement = function () {}, t.prototype.assignQueue = function () {}, t.prototype.push = function () {}, t.prototype.setUseType = function () {}, t.prototype.resetUseType = function () {}, t.prototype.validateHTML = function () {}, t.prototype.enableDevMode = function () {}, t.prototype.enableHTMLTracking = function () {}, t.prototype.setEventsContext = function (t) {}, t;
    }();

    e.FakeTracker = r;
  }]);
});